import { Grid, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useStore } from '@roc/client-portal-shared/hooks';
import { useEffect } from 'react';
import { PersonalAndCreditInformationLink } from './subcomponents/personalAndCreditInformationLink';
import { PersonalAndCreditInformationSteps } from './subcomponents/personalAndCreditInformationSteps';
import { PersonalAndCreditInformationSections } from './subcomponents/personalAndCreditInformationSections';
import { PersonalAndCreditInformationOptions } from './subcomponents/personalAndCreditInformationOptions';
import { PersonalAndCreditInformationErrors } from './subcomponents/personalAndCreditInformationErrors';
import { Document } from '@roc/feature-types';

export type PersonalAndCreditInformationProps = {
  borrowerId: number;
  loan?: any;
  handleClose: () => void;
  refreshLoan?: () => void;
  document?: Document;
};

export const PersonalAndCreditInformation = observer((props: PersonalAndCreditInformationProps) => {

  const { borrowerId, loan, handleClose, refreshLoan, document } = props;

  const { borrowerSetupToDoStore } = useStore();
  const { isBorrowerUser, showStepsLayout } = borrowerSetupToDoStore;

  useEffect(() => {
    borrowerSetupToDoStore.reset();
    borrowerSetupToDoStore.loadBorrowerPrescreenInfo(borrowerId, loan);
  }, []);

  return (
    <Grid container spacing={2} style={{
      width: '100%',
      minHeight: '180px'
    }}>
      {!isBorrowerUser &&
        <PersonalAndCreditInformationOptions store={borrowerSetupToDoStore} refreshLoan={refreshLoan} document={document} />
      }
      {borrowerSetupToDoStore.borrowerDetailsVerification && !isBorrowerUser &&
        <PersonalAndCreditInformationErrors store={borrowerSetupToDoStore} />
      }
      {borrowerSetupToDoStore.borrowerDetailsVerification ?
        <>
          {borrowerSetupToDoStore.sendIdVerificationPending && borrowerSetupToDoStore?.setupPending && !isBorrowerUser ?
            <PersonalAndCreditInformationLink store={borrowerSetupToDoStore} />
            :
            <>
              {showStepsLayout === true &&
                <>
                  {borrowerSetupToDoStore.sendIdVerification && isBorrowerUser &&
                    <PersonalAndCreditInformationSteps store={borrowerSetupToDoStore} handleClose={handleClose} />
                  }
                </>
              }
              {showStepsLayout === false &&
                <>
                  {borrowerSetupToDoStore.sendIdVerification &&
                    <PersonalAndCreditInformationSections store={borrowerSetupToDoStore} handleClose={handleClose} />
                  }
                </>
              }
            </>
          }
        </> : (
          <>
            {isBorrowerUser && (
              <Grid item xs={12} container>
                <Typography>No action needed.</Typography>
              </Grid>
            )}
          </>
        )
      }
      <Grid item xs={12} />
    </Grid>
  );
});